/**
 * The Privacy Policy and Terms & Conditions shown inside the portal (PP-029 / proweb-102).
 *
 * THIS FILE IS WHERE THE APPROVED TEXT GOES. `sections` is empty until Business/Legal supply it, and
 * both pages render their canonical-source notice instead of prose while that is the case.
 *
 * It is deliberately not filled in from the public web pages. PP-029 AC-006 allows only the latest
 * Business/Legal-approved version to be displayed and AC-007 requires Compliance sign-off before
 * production; a copy scraped from a marketing site is neither, and an approximate privacy policy is
 * worse than an honest link to the authoritative one. Paste the approved text into `sections` and the
 * pages render it with no further change.
 */
export interface LegalSection {
  readonly heading: string;
  /** Paragraphs, in order. Plain text — the renderer escapes it; no markup is interpreted. */
  readonly paragraphs: readonly string[];
}

export interface LegalDocument {
  readonly title: string;
  /** Shown so a reader can tell which revision they are looking at (AC-006). */
  readonly revision: string | null;
  readonly sourceUrl: string;
  readonly sections: readonly LegalSection[];
}

export const PRIVACY_POLICY: LegalDocument = {
  title: 'Privacy Policy',
  revision: null,
  sourceUrl: 'https://bankersfidelity.com/privacypolicy/',
  sections: [],
};

export const TERMS_AND_CONDITIONS: LegalDocument = {
  title: 'Terms & Conditions',
  revision: null,
  sourceUrl: 'https://bankersfidelity.com/termsofuse/',
  sections: [],
};
